export const isDigitsOnly = /^(?=.*\d)[\d ]+$/;